// @flow

import React, { Fragment, type Node } from 'react';
import { connect } from 'react-redux';

import { Grid, Row } from 'clark-styles';
import { setActiveTab } from 'actions/application';
import { type StateType as ReducersStateType } from 'reducers';
import { TabContainer, StyledCol, Tab } from './styles';

const mapStateToProps = ({ application: { activeTab } }: ReducersStateType) => ({ activeTab });
const mapDispatchToProps = { dispatchSetActiveTab: setActiveTab };

type TabType = { name: string, content: Node };
type PropsType = {
  tabs: Array<TabType>,
  activeTab: number,
  dispatchSetActiveTab: typeof setActiveTab,
};

export const TabsComponent = ({ tabs, activeTab, dispatchSetActiveTab }: PropsType) => (
  <Fragment>
    <TabContainer>
      <Grid>
        <Row>
          <StyledCol sm={12} md={12} lg={12}>
            {tabs.map(({ name }, i) => (
              <Tab key={name} isActive={i === activeTab} onClick={() => dispatchSetActiveTab(i)}>
                {name}
              </Tab>
            ))}
          </StyledCol>
        </Row>
      </Grid>
    </TabContainer>
    {tabs[activeTab].content}
  </Fragment>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TabsComponent);



// WEBPACK FOOTER //
// ./src/components/tabs/index.js